<template v-if="loading">
  <v-form>
    <v-container v-if="loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate :size="150" :width="8" color="green"></v-progress-circular>
      </div>
    </v-container>
    <v-container v-else>
      <div style="height: 10px;"></div>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="代理店・個人発注依頼ファイル"
            @click="pickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            hint="CSVファイル"
            v-validate="'required'"
            data-vv-name="userId"
            :error-messages="errors.collect('itemId')"
          ></v-text-field>
          <input
            type="file"
            ref="file"
            style="display: none"
            accept=".csv, .xls"
            @change="onFileChange($event)"
          />

          <v-radio-group v-model="fileFormat" row :mandatory="false">
            <v-radio label="SHIFT-JIS" value="SHIFT-JIS"></v-radio>
            <v-radio label="UTF-8" value="UTF-8"></v-radio>
          </v-radio-group>          
          <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>
        </v-flex>
      </v-layout>

      <div style="height: 20px;"></div>
      <br />

      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div style="height: 50px;"></div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
export default {
  created() {
    console.log('created')

    // 初期表示時の
    this.loading = false
  },
  methods: {
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      console.log('fileUpload')

      let thisObj = this
      // FormData를 사용해서 파일을 등록한다
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true
      ServerApiCallService.sendOrdersFile(formData, sendContext)
        .then(response => {
          thisObj.loading1 = false

        })
        .catch(error => {
          thisObj.loading1 = false
        })
    },
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false, // 버튼의 빙글빙글 돌게 하는거
      fileName: '',
      fileFormat: 'SHIFT-JIS',
    }
  }
}
</script>